const BODY_TOUCH_ACTION_KEY = 'data-ion-scroll-lock-touch-action';
const BODY_OVERFLOW_KEY = 'data-ion-scroll-lock-overflow';

/** Restore entries for ion-content scroll elements (overflow + touchAction). */
const ionScrollRestore: Array<{
  el: HTMLElement;
  overflow: string;
  touchAction: string;
}> = [];

let lockDepth = 0;

/**
 * Lock body and IonContent scroll (e.g. during drag or iOS swipe-back).
 * Reference-counted so nested locks are safe.
 */
export function lockIonContentScroll(): void {
  lockDepth += 1;
  if (lockDepth > 1) {
    return;
  }

  const body = document.body;
  if (!body.hasAttribute(BODY_TOUCH_ACTION_KEY)) {
    body.setAttribute(BODY_TOUCH_ACTION_KEY, body.style.touchAction || '');
    body.style.touchAction = 'none';
  }
  if (!body.hasAttribute(BODY_OVERFLOW_KEY)) {
    body.setAttribute(BODY_OVERFLOW_KEY, body.style.overflow || '');
    body.style.overflow = 'hidden';
  }

  const ionContents = document.querySelectorAll<HTMLElement>('ion-content');
  ionContents.forEach((ionContent) => {
    const root = ionContent.shadowRoot;
    if (!root) return;
    const selectors = ['.inner-scroll', '.scroll-content'];
    selectors.forEach((sel) => {
      const el = root.querySelector<HTMLElement>(sel);
      if (!el) return;
      ionScrollRestore.push({
        el,
        overflow: el.style.overflow || '',
        touchAction: el.style.touchAction || '',
      });
      el.style.overflow = 'hidden';
      el.style.touchAction = 'none';
    });
  });
}

export function unlockIonContentScroll(): void {
  if (lockDepth === 0) {
    return;
  }

  lockDepth -= 1;
  if (lockDepth > 0) {
    return;
  }

  const body = document.body;
  const prevTouch = body.getAttribute(BODY_TOUCH_ACTION_KEY);
  body.removeAttribute(BODY_TOUCH_ACTION_KEY);
  body.style.touchAction = prevTouch ?? '';
  const prevOverflow = body.getAttribute(BODY_OVERFLOW_KEY);
  body.removeAttribute(BODY_OVERFLOW_KEY);
  body.style.overflow = prevOverflow ?? '';

  ionScrollRestore
    .splice(0, ionScrollRestore.length)
    .forEach(({ el, overflow, touchAction }) => {
      el.style.overflow = overflow;
      el.style.touchAction = touchAction;
    });
}
